/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentControllerCreateRequest { 
    companyId: string;
    areaId: string;
    typeId: string;
    name: string;
    description?: string;
    /**
     * Palabras clave separadas por coma
     */
    keywords?: string;
    /**
     * Responsable del documento
     */
    ownerUserId?: number;
    restricted?: boolean;
    /**
     * Si se omite, hereda la política del tipo
     */
    allowDownload?: boolean;
    /**
     * Consecutivo escrito a mano. Si se omite, se toma el que propone el sistema
     */
    sequence?: number;
}

